<template>
  <v-expansion-panels style="background-color: #eee; margin-top: 10px; z-index: 0">
    <v-expansion-panel>
      <v-expansion-panel-header style="background-color: #eee;">
        <div>
          <v-icon>mdi-image</v-icon>
          <b style="font-size: 14px; font-weight: 600; padding-left: 10px">
            {{ index.replace("IMAGE_", "") }}
          </b>
        </div>

        <div v-if="!isNew">
           <b>{{ value.value.name }} ({{ value.value.width }}px x
            {{ value.value.height }}px,
            {{ Math.ceil(value.value.size / 1024) }} Kb)</b>
        </div>

      </v-expansion-panel-header>
      <v-expansion-panel-content class="custom-panel-content">

        <div style="padding: 0px 0px 0px 10px">
          <v-switch v-model="editMode" label="Edit Mode" v-if="isNew" />
        </div>

        <v-card style="background-color: #eee" v-if="isNew && editMode">
          <v-card-text class="text-h5 font-weight-bold">
            <v-image-input v-model="base64" :image-quality="1" clearable _image-format="jpeg" @file-info="onFileInfo"
              @input="onInput" _imageMinScaling="contain" :imageWidth="imgWidth" :imageHeight="imgHeight"
              overlayPadding="20px" />
            <v-slider v-model="imgWidth" class="align-center" :max="800" :min="50" hide-details>
              <template slot="append">
                <v-text-field v-model="imgWidth" class="mt-0 pt-0" hide-details single-line type="number"
                  style="width: 60px"></v-text-field>
              </template>
            </v-slider>
            <v-slider v-model="imgHeight" class="align-center" :max="800" :min="50" hide-details>
              <template slot="append">
                <v-text-field v-model="imgHeight" class="mt-0 pt-0" hide-details single-line type="number"
                  style="width: 60px"></v-text-field>
              </template>
            </v-slider>
          </v-card-text>

          <v-card-actions>
            <v-btn :loading="loadingStore" :disabled="!base64" color="primary lighten-2" @click="storeImage">
              Store Image
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card style="background-color: #eee" v-if="isNew && !editMode">
          <v-card-text class="text-h5 font-weight-bold">
            <core-file-upload ref="fileUpload" @input="storeImage" label="Trascina qua l'immagine che vuoi caricare" />
          </v-card-text>
        </v-card>

        <v-card style="background-color: #eee" v-if="!isNew">
          <v-card-text class="text-h5 font-weight-bold">
            <v-img :max-height="localValue.value.height" :max-width="localValue.value.width" :src="imgPath"
              @click="copyUrlToClipboard()"></v-img>
          </v-card-text>
          <v-card-actions>
            <v-btn small color="lighten-2 warning" @click="deleteImage">
              <v-icon small>mdi-delete</v-icon>
              Remove Image
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
let { post } = require("@/api/base_entity");
import { mapActions } from 'vuex'

export default {
  props: {
    value: { type: Object, default: () => null },
    index: { type: String, default: "" },
    entityId: { type: Number },
    entity: { type: String },
    i18n: { type: Boolean, default: false },
    languages: { type: Array, default: () => ["EN", "IT", "DE", "FR", "ES"] }
  },
  data() {
    return {
      base64: null,
      image: {
        entity: this.entity,
        entity_id: this.entityId
      },
      imgHeight: 320,
      imgWidth: 480,
      loadingStore: false,
      editMode: false,
      // localValue: { type: "cms-image", value: null, i18n: this.i18n }
      localValue: this.value || null
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.localValue = newValue;
      },
      deep: true,
    }
  },
  mounted() {
    this.getConfig()
  },
  computed: {
    isNew() {
      return !this.localValue || !this.localValue.value || !this.localValue.value.uuid;
    },
    // imgPath() {
    //   return (
    //     // this.$store.getters.s3BaseUrl +
    //     this.$store.getters.siteUrl +
    //     this.$store.getters.staticFileUrl + '/' +
    //     this.localValue.value.uuid +
    //     this.localValue.value.extension
    //   )
    // },
    imgPath() {
      return (
        this.$store.getters.s3BaseUrl +
        this.value.value.uuid +
        this.value.value.extension
      );
    },
  },
  methods: {
    ...mapActions('app', ['getConfig']),
    onFileInfo(info) {
      this.image = info
      this.image.entity = this.entity
      this.image.entity_id = this.entityId
    },
    onInput(base64) {
      this.image.base64 = base64;
    },
    async storeImage(val) {

      if (val.base64) {
        this.image = {
          'lastModified': val.lastModified,
          'name': val.name,
          'size': val.size,
          'type': val.type,
          'base64': val.base64,
          'entity': this.entity,
          'entity_id': this.entityId
        }
      }

      this.loadingStore = true;

      let ret = null

      try {
        ret = await post("file", this.image);
      } catch (error) {
        this.$root.$emit('openSnackbar', {
          message: 'Si è verificato un errore durante il caricamento del file : ' + error.response.data.message || 'Error',
          color: 'error'
        });
        this.$refs.fileUpload.setBusy(false);
        this.loadingStore = false;
        return;
      }

      this.updateValue(ret.data); {
        this.localValue = {}
      }
      this.$root.$emit('openSnackbar', {
        message: 'Immagine caricata con successo!',
        color: 'success'
      })

      this.loadingStore = false;
      this.$refs.fileUpload.setBusy(false)

    },
    deleteImage() {
      this.localValue = null
      this.$emit('input', this.localValue);
      this.image = null;
      this.base64 = null;
    },
    updateValue(newValue) {
      if (!this.localValue) {
        this.localValue = {}
      }
      this.localValue.value = newValue;
      this.localValue.type = "cms-image";
      this.$emit('input', this.localValue);
    },
    copyUrlToClipboard() {
      const url = this.imgPath;
      navigator.clipboard.writeText(url).then(() => {
        this.$root.$emit('openSnackbar', {
          message: 'Image URL copied to clipboard!',
          color: 'success'
        })
      }, () => {
        this.$root.$emit('openSnackbar', {
          message: 'Failed to copy image URL to clipboard!',
          color: 'error'
        })
      });
    }
  },
};
</script>

<style>
.imageComponent {
  background-color: rgb(102, 102, 102);
}

.custom-panel-content .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>